import { EditTransferTypePanel } from "@/components/organisms";

export const TransferTypesEdit = () => {
  return <EditTransferTypePanel />;
};
